
  <Styles :styles="styles"/>
  <component v-if="ready" :key="version" :is="widget()" v-bind="this.props"/>
